import type { Theme } from "@emotion/react";
import { css } from "@emotion/react";

import { mobileNavheight } from "@aviary/layouts/SidebarLayout/MobileTopBar/MobileTopBar.styles";
import * as baseStyles from "@styles/emotion-styles/baseStyles";
import * as dimensions from "@styles/emotion-styles/dimensions";
import * as layers from "@styles/emotion-styles/layers";

export const stickyHeader = (theme: Theme) => css`
  display: none;
  position: fixed;
  top: 4.0625rem;
  left: 0;
  background-color: ${theme.surface.level2};
  height: 4rem;
  width: 100%;
  padding: 0 2rem;

  @media (max-width: ${dimensions.tabletMax}) {
    padding: 0 1rem;
    top: 4rem;
  }

  ${baseStyles.cardShadow(theme)};
  z-index: ${layers.indexOverlayMin};
`;

export const drawerHeader = css`
  @media (min-width: ${dimensions.tablet}) {
    width: 80vw;
  }

  @media (min-width: ${dimensions.widescreenMax}) {
    width: 60vw;
  }
`;

export const bannersAdjust = (bannersHeight: number) => css`
  top: ${bannersHeight}px;
  @media (max-width: ${dimensions.tabletMax}) {
    top: calc(${bannersHeight}px + ${mobileNavheight});
  }
`;

export const showStickyHeader = css`
  display: flex;
  justify-content: center;
`;

export const stickyHeaderDrawer = css`
  top: 0;
  margin-left: -2rem;
  left: auto;
  width: calc(100% - 2rem);

  justify-content: space-between;

  @media (max-width: ${dimensions.tabletMax}) {
    &&& {
      top: 0;
    }
  }

  @media (max-width: ${dimensions.phoneLargeMax}) {
    margin-left: -1rem;
    width: 100%;
  }
`;

export const isUnauthenticated = css`
  top: 4.75rem;
  z-index: ${layers.indexPageHeaderMax};

  @media (max-width: ${dimensions.tabletMax}) {
    top: 4.75rem;
  }

  @media (max-width: ${dimensions.phoneLargeMax}) {
    top: 0;
  }
`;

export const isPatient = css`
  top: calc(4rem + var(--smartbanner-height, 0px));

  @media (max-width: ${dimensions.tabletMax}) {
    top: calc(3.5rem + var(--smartbanner-height, 0px));
  }
`;

export const innerMenu = css`
  flex-grow: 1;

  max-width: 80rem;

  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const innerMenuDrawer = css`
  max-width: 77vw;

  @media (max-width: ${dimensions.phoneLargeMax}) {
    max-width: none;
  }
`;

export const resultsText = css`
  &&& {
    margin-bottom: 0;
  }
`;

export const gridListSelector = css`
  @media (max-width: ${dimensions.phoneSmallMax}) {
    display: none;
  }
`;

export const rightOptions = css`
  display: flex;

  @media (max-width: ${dimensions.phoneMax}) {
    display: none;
  }
`;

export const children = css`
  margin-right: 1rem;

  @media (max-width: ${dimensions.tabletMax}) {
    margin-right: 0;
  }
`;
